export class CommentModel {
  id: number;
  sequence: number;
  type: string;
  text: string;
}
